import { render, staticRenderFns } from "./playerGZ.vue?vue&type=template&id=b337c480&scoped=true"
import script from "./playerGZ.vue?vue&type=script&lang=js"
export * from "./playerGZ.vue?vue&type=script&lang=js"
import style0 from "./playerGZ.vue?vue&type=style&index=0&id=b337c480&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337c480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b337c480')) {
      api.createRecord('b337c480', component.options)
    } else {
      api.reload('b337c480', component.options)
    }
    module.hot.accept("./playerGZ.vue?vue&type=template&id=b337c480&scoped=true", function () {
      api.rerender('b337c480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/player/playerGZ.vue"
export default component.exports